export enum ZOA {
  cat = 'cat',
  dog = 'dog',
  pig = 'pig',
  horse = 'horse',
  sheep = 'sheep'
}
